
import { defineComponent } from 'vue'
import QBtn from 'quasar/src/components/btn/QBtn.js';import QCard from 'quasar/src/components/card/QCard.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QImg from 'quasar/src/components/img/QImg.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';
import { LSKeys } from '@/assets/constants';

export default defineComponent({
    components: {
        QBtn, 
        QCard, 
        QDialog, 
        QSeparator,
        QCardSection,
        QImg,
        QCardActions,
    },
    emits: [
        ...useDialogPluginComponent.emits,
    ],
    setup() {
        const { dialogRef, onDialogHide } = useDialogPluginComponent();
        return { dialogRef, onDialogHide }
    },
    methods: {
        hide() {
            this.dialogRef?.hide();
            localStorage.setItem(LSKeys.hasSeenHelp, JSON.stringify(true));
        }
    }
})
